<template>
  <transition
    appear
    @enter="cookieEnter"
    @leave="cookieLeave"
  >
    <div
      v-if="show"
      class="c-template c-template--cookie grid"
      :data-theme="theme"
      style="opacity: 0;"
    >
      <div class="cookie__inner">
        <slot
          v-for="slot in slots"
          :name="slot"
        />
      </div>
    </div>
  </transition>
</template>

<script>
import { TimelineLite, Expo } from 'gsap/TweenMax';

export default {
  name: 'CookieTemplate',

  props: {
    theme: {
      type: String,
      required: false,
      default: 'default',
    },
    slots: {
      type: Array,
      required: false,
      default() {
        return ['content', 'button'];
      },
    },
    animation: {
      type: Object,
      required: false,
      default() {
        return {
          css: false,
          name: '',
          mode: 'in-out',
          enter: (element, done) => { done(); },
          leave: (element, done) => { done(); },
        };
      },
    },
  },

  data() {
    return {
      show: true,
    };
  },

  created() {
    if (localStorage.getItem('cookie:accepted')) {
      this.show = false;
    }
    this.$on('cookie-accepted', () => { this.show = false; });
  },

  methods: {
    cookieEnter(el, done) {
      const tl = new TimelineLite({
        delay: 2,
        onComplete: done,
      });

      tl.add('label')
      .set(el, {
        autoAlpha: 1,
        yPercent: 100,
      }, 'start')
      .set(el.children[0], {
        yPercent: 50,
        autoAlpha: 0,
      }, 'start')
      .to(el, 0.75, {
        yPercent: 0,
        ease: Expo.easeOut,
      }, 'start+=0.5')
      .to(el.children[0], 0.75, {
        yPercent: 0,
        autoAlpha: 1,
        ease: Expo.easeOut,
      }, 'start+=0.7')

    },
    cookieLeave(el, done) {
      const tl = new TimelineLite({
        onComplete: done,
      });

      tl.add('label')
      .to(el.children[0], 0.5, {
        autoAlpha: 0,
        ease: Expo.easeOut,
      }, 'start+=0.2')
      .to(el, 0.5, {
        yPercent: 100,
        ease: Expo.easeOut,
      }, 'start+=0.5')
    },
  }
};
</script>

<style lang="scss" scoped>
.c-template.c-template--cookie {
  position: absolute;
  box-sizing: border-box;
  left: 0;
  bottom: 0;
  width: 100vw;

  background: $color-bg;
  padding: rem(30px) rem(20px);

  color: rgba($color-text, 0.7);
  display: grid;

  z-index: 105;

  border-top: 1px solid $color-dark-light;
  backface-visibility: hidden;

  grid-template-columns: 0fr 1fr 0fr;
  grid-template-areas: 'a cookie b';

  @include mq($and: $is-touch-device) {
    position: fixed;
  }

  @include mq(ipadL) {
    padding: rem(30px) rem(30px);
  }

  @include mq(d) {
    padding: rem(30px) rem(60px);
  }

  @include mq(dl) {
    padding: rem(30px) 0;
    grid-template-columns: 1fr 2fr 1fr;
  }

  & ::v-deep a {
    color: $color-text;
  }
}
.cookie__inner {
  position: relative;
  grid-area: cookie;

  backface-visibility: hidden;

  @include mq(ipadP) {
    display: flex;
    flex-flow: row wrap;
    align-items: center;
    justify-content: space-between;
  }
}
</style>
